// src/components/ui/card.jsx
import * as React from "react";
import { cn } from "./utils";

const Card = React.forwardRef(({ className, ...props }, ref) => (
	<div ref={ ref } className={ cn("rounded-xl border bg-white text-card-foreground shadow", className) } { ...props } />
));
Card.displayName = "Card";

const CardHeader = ({ className, ...props }) => (
	<div className={ cn("flex flex-col space-y-1.5 p-6", className) } { ...props } />
);
const CardContent = ({ className, ...props }) => (
	<div className={ cn("p-6 pt-0", className) } { ...props } />
);
const CardFooter = ({ className, ...props }) => (
	<div className={ cn("flex items-center p-6 pt-0", className) } { ...props } />
);

export { Card, CardHeader, CardContent, CardFooter };